document.addEventListener('DOMContentLoaded', () => {
  const modals = document.querySelectorAll('.product-media-modal--prestige');

  modals.forEach((modal) => {
    const content = modal.querySelector('.product-media-modal__content');
    const prevBtn = modal.querySelector('.product-media-modal__nav--prev');
    const nextBtn = modal.querySelector('.product-media-modal__nav--next');

    if (!content || !prevBtn || !nextBtn) return;

    const getItems = () =>
      Array.from(content.children).filter((item) => {
        return !item.hasAttribute('hidden');
      });

    const getActiveIndex = () => {
      const items = getItems();
      const activeIndex = items.findIndex((item) => item.classList.contains('active'));
      return activeIndex >= 0 ? activeIndex : 0;
    };

    const showItemByIndex = (newIndex) => {
      const items = getItems();
      if (!items.length) return;

      if (newIndex < 0) newIndex = items.length - 1;
      if (newIndex >= items.length) newIndex = 0;

      const target = items[newIndex];
      if (!target) return;

      const mediaId = target.getAttribute('data-media-id');
      if (!mediaId) {
        target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        return;
      }

      const openerButton = document.querySelector(
        `.product__media-toggle[data-media-id="${mediaId.replace(/[^\d]/g, '')}"]`
      );

      if (openerButton) {
        openerButton.click();
      } else {
        target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    };

    prevBtn.addEventListener('click', () => {
      showItemByIndex(getActiveIndex() - 1);
    });

    nextBtn.addEventListener('click', () => {
      showItemByIndex(getActiveIndex() + 1);
    });

    modal.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showItemByIndex(getActiveIndex() - 1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        showItemByIndex(getActiveIndex() + 1);
      }
    });
  });
});